import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface LoadMoreProps {
  onClick: () => void;
  loading?: boolean;
  hasMore: boolean;
}

export function LoadMore({ onClick, loading = false, hasMore }: LoadMoreProps) {
  const { t } = useTranslation();
  
  if (!hasMore) return null;

  return (
    <div className="flex justify-center mt-12">
      <button
        onClick={onClick}
        disabled={loading}
        aria-label={t('common.loading_more')}
        className="btn-outline flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? (
          <>
            <Loader2 className="w-5 h-5 animate-spin" />
            <span>{t('common.loading_more')}</span>
          </>
        ) : (
          <span>{t('common.loadMore')}</span>
        )}
      </button>
    </div>
  );
}